import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Response } from "@angular/http";
import { Observable, Subscription } from "rxjs/Rx";
import { Item } from "./item.model";
import { ItemService } from "./item.service";
import { CONFIG } from "../../shared/constants/config.constants";
import { TranslateService } from "../../../language/translate.service";
// import { ItemService as CustomerService } from '../../management/customers/item.service';

@Component({
  selector: "jhi-client-management-edit",
  templateUrl: "./item-edit.component.html",
  styleUrls: ["item-edit.component.styl"]
})
export class ItemEditComponent implements OnInit {
  item: Item;
  isSaving: boolean;
  isEditItemScreen = false;
  customerTypes = CONFIG.customerTypes;
  typeSendInvoices = CONFIG.typeSendInvoices;
  isOrg: boolean;
  isMail: boolean = true;
  private subscription: Subscription;

  constructor(
    private itemService: ItemService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService // private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.item = new Item();
    this.isSaving = false;
    this.isOrg = true;
    this.subscription = this.route.params.subscribe(params => {
      const id = params["id"];

      if (id && id !== "new") {
        this.isEditItemScreen = true;
        this.load(id);
      }
    });
  }

  load(id) {
    this.itemService.find(id).subscribe(item => {
      this.item = item;
      if (this.item.isOrg == false) {
        this.isOrg = false;
        this.item.customerName = this.item.personContact;
      }
      if (this.item.typeSendInvoice == 1) {
        this.isMail = true;
      } else {
        this.isMail = false;
      }
    });
  }

  clear() {
    this.router.navigate(["/invoice-list"]);
  }

  save() {
    this.subscribeToSaveResponse(this.itemService.update(this.item));
  }

  private subscribeToSaveResponse(result: Observable<Item>) {
    result.subscribe(
      (res: Item) => this.onSaveSuccess(res),
      (res: Response) => this.onSaveError(res)
    );
  }

  private onSaveSuccess(result: Item) {
    this.isSaving = false;
    // this.router.navigate(['/invoice-list']);

    const messageKey = "Cập nhật thành công";
    setTimeout(() => {
      this.router.navigate(
        [
          {
            outlets: {
              notification: "notification/" + messageKey
            }
          }
        ],
        {
          replaceUrl: true
        }
      );
    });
  }

  private onSaveError(error) {
    this.isSaving = false;
    this.onError(error);
  }

  private onError(error) {}

  checkedChange(isOrg: boolean) {
    this.isOrg = isOrg;

    if (this.isOrg === false) {
      this.item.personContact = this.item.customerName;
    }
  }
  checkTypeSend(isSendMail: boolean) {
    if (isSendMail) {
      this.isMail = true;
    } else {
      this.isMail = false;
    }
  }
  customerNameChange(customerName: string) {
    if (this.isOrg === false) {
      this.item.personContact = customerName;
    }
  }

  checkBankAccount(event) {
    if (event.key.length <= 1 && !event.ctrlKey) {
      if (isNaN(Number(event.key)) || event.key === " ") {
        // check dấu phân cách thập phân
        event.preventDefault();
        return;
      }
    }
  }
}
